import React, { InputHTMLAttributes } from "react";

interface AddTitleProps extends InputHTMLAttributes<HTMLInputElement> {
  heading: string;
  subheading?: string;
  maxLength?: number;
  index?: number;
  error?: string;
}

export const SKInput = ({ heading, subheading, maxLength, index, error, ...inputProps }: AddTitleProps) => {
  const { disabled, value, type } = inputProps;

  return (
    <>
      <div className={"relative w-full min-w-[200px] mb-2 mt-4 "}>
        <div className="flex items-center space-x-2">
          {index && (
            <div
              className={`flex items-center justify-center w-5 h-5 text-sm ${
                !disabled ? "text-black" : " text-gray-500"
              } border-2 border-black rounded-full`}
            >
              {index}
            </div>
          )}
          <span className="text-lg font-bold">{heading}</span>
        </div>
        {subheading && <p className="mb-4 text-sm text-gray-400">{subheading}</p>}
        <input
          {...inputProps}
          type="text"
          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        />
        {error && <span className="block mb-2 text-sm text-red-600 dark:text-red-500">{error}</span>}
        {!error && maxLength && type === "text" && (
          <span className="block mb-2 text-sm text-gray-400 dark:text-gray-600">
            {maxLength - (typeof value === "string" ? value.length : 0)} Characters Remaining.
          </span>
        )}
      </div>
    </>
  );
};
